module.exports = __webpack_public_path__ + "img/Genesis-banner-bigpack-copy.12812a70.jpg";